<script lang="ts">
    import { apiBaseURL } from "../../../config"
    export let col: Column
    export let pageId: string

    let active = -1
    setInterval(() => {
        active += 1
        if (active == col.iconCycleSquare.boxes.length) active = 0
    }, 1250)
</script>

<div class="iconCycleSquares">
    {#each col?.iconCycleSquare?.boxes as box, i}
        <div class="box" id="box{i}" class:active="{i == active}">
            <div class="content">
                <div class="icon">
                    <svg
                        stroke="{i == active ? 'black' : 'white'}"
                        fill="{i == active ? 'black' : 'white'}"
                        data-src="{apiBaseURL}page/{pageId}/{box.icon?.src}"></svg>
                </div>
                <div class="text">
                    {box.text}
                </div>
            </div>
        </div>
    {/each}
</div>

<style lang="less">
    @import "../../assets/css/main.less";
    .iconCycleSquares {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        gap: 10px;
        font-size: 0.8rem;
        transition: background-color 600ms;

        @media @tablet {
            font-size: 1rem;
        }
        .box {
            border: 4px solid @bg-color-secondary;
            background-color: @bg-color-secondary;
            display: flex;
            align-items: center;
            justify-content: center;
            color: @font-color-secondary;
            padding: 10px;
            &.active {
                background-color: @bg-color;
                color: @font-color;
            }
            aspect-ratio: 1/1;
            width: calc((100% / 2) - 10px);
            @media (min-width: 950px) and (max-width: 1450px) {
                width: calc((100% / 4) - 10px);
            }
            @media (min-width: 1450px) {
                width: calc((100% / 5) - 10px);
            }
            .content {
                display: flex;
                flex-direction: column;
                align-items: center;
                @media @tablet {
                    gap: 20px;
                }
                .text {
                    width: 100%;
                    display: flex;
                    justify-content: center;
                    text-align: center;
                    font-family: "Libre Caslon Text", serif;
                }
            }
        }
    }
</style>
